import type { useTranslations } from 'next-intl';
import { ClientLink } from '@/app/components/shared/ClientLink';

export const QUESTIONS_CONFIG = (t: ReturnType<typeof useTranslations>) => {
  return [
    {
      id: 'answer1',
      question: t('question1'),
      answer: [
        {
          title: t('answer1.item1'),
        },
        {
          title: t('answer1.item2'),
        },
      ],
    },
    {
      id: 'answer2',
      question: t('question2'),
      answer: [
        {
          title: t('answer2.item1'),
          children: [t('answer2.item2'), t('answer2.item3'), t('answer2.item4')],
        },
        {
          title: t('answer2.item5'),
        },
      ],
    },
    {
      id: 'answer3',
      question: t('question3'),
      answer: [
        {
          title: t('answer3.item1'),
          children: [t('answer3.item2')],
        },
        {
          title: t('answer3.item3'),
          children: [t('answer3.item4')],
        },
      ],
    },
    {
      id: 'answer4',
      question: t('question4'),
      answer: [
        {
          title: t('answer4.item1'),
        },
      ],
    },
    {
      id: 'answer5',
      question: t('question5'),
      answer: [
        {
          title: t('answer5.item1'),
        },
      ],
    },
    {
      id: 'answer6',
      question: t('question6'),
      answer: [
        {
          title: t('answer6.item1'),
          children: [
            t.rich('answer6.item2', {
              link: (chunks) => (
                <ClientLink
                  className="cursor-pointer underline"
                  href="https://discord.gg/3pDU8fmQ8Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </ClientLink>
              ),
            }),
            t.rich('answer6.item3', {
              span: (chunks) => (
                <ClientLink
                  className="cursor-pointer underline"
                  href="/help-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </ClientLink>
              ),
            }),
          ],
        },
      ],
    },
  ];
};
